import { ReactElement, RefObject } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PostListItem, ReactionStats } from 'api';
import welcomePost from 'assets/images/welcomePost.png';
import { useCompanyDetails } from 'components/Dialogs/hooks';
import { PostTopBar } from 'components/PostTopBar';
import { ReactionsWrapper } from 'components/ReactionsWrapper';
import { InViewItemRef } from 'types';

import { Container, LeftSide, LinkW, PostContentWrapper, PostTitle, PostW } from '../styled';
import { WelcomeDescription, WelcomeImage } from './styled';

interface WelcomePostProps {
  id: string;
  author: PostListItem['author'];
  authorName: string;
  publishedAt: string;
  reactions?: ReactionStats;
  comments_count?: number;
  postRef: RefObject<HTMLDivElement>;
  lastItemRef?: InViewItemRef;
  onNavigateToNewUser: () => void;
  handlePostClick?: () => void;
  handleOpenReactionModal?: () => void;
  isSlider?: boolean;
}

export function WelcomePost({
  id,
  author,
  authorName,
  publishedAt,
  reactions,
  comments_count,
  postRef,
  lastItemRef,
  onNavigateToNewUser,
  handlePostClick,
  handleOpenReactionModal,
  isSlider,
}: WelcomePostProps): ReactElement {
  const { t } = useTranslation();
  const { company } = useCompanyDetails();

  return (
    <Container ref={postRef}>
      <PostW ref={lastItemRef} isAutomatedPost isSlider={isSlider}>
        <PostContentWrapper>
          <PostTopBar
            id={id}
            postTitle={t('post.listItem.welcomePost.title', {
              user: authorName,
            })}
            authorName={company?.name || ''}
            author={author}
            publishedAt={publishedAt}
            isAutomatedPost
          />
          <LeftSide>
            <WelcomeImage src={welcomePost} alt="welcome post image" />
            <PostTitle>
              {t('post.listItem.welcomePost.title', {
                user: authorName,
              })}
            </PostTitle>
            <WelcomeDescription>
              <Trans
                i18nKey="post.listItem.welcomePost.description"
                values={{
                  linkLabel: authorName,
                }}
              >
                We have some great news to share. Our family grows! Take a chance to say hello to{' '}
                <LinkW
                  onClick={(e: { stopPropagation: () => void }) => {
                    e.stopPropagation();
                    onNavigateToNewUser();
                  }}
                >
                  {authorName}
                </LinkW>
              </Trans>
            </WelcomeDescription>
          </LeftSide>
        </PostContentWrapper>
        <ReactionsWrapper
          id={id}
          isPreview={false}
          reactions={reactions}
          comments_count={comments_count}
          handlePostClick={handlePostClick}
          handleOpenReactionModal={handleOpenReactionModal}
        />
      </PostW>
    </Container>
  );
}
